export const regex = {
    regexForName : /^([a-zA-Z]+\s)*[a-zA-Z]+$/,
    regexForEmail : /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/,
    regexForPhone : /^[().0-9\s+-]+$/,
    // regexForPhone : /^((\+44(\s\(0\)\s|\s0\s|\s)?)|0)7\d{3}(\s)?\d{6}$/,
    // regexForPhone : /^(?:(?:(?:00\s?|\+)44\s?|0)7(?:[1345789]\d{2}|624)\s?\d{3}\s?\d{3})$/,
    regexForNoAlphabets : /^[a-zA-Z]*$/,
    regexForURL : /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/,
    regexForAddress : /^[#&/().0-9a-zA-Z\s,-]+$/,
    regexForCustomVisa : /^[#&/().0-9a-zA-Z\s,-]+$/,
    regexForCharNum : /^[a-zA-Z0-9_.-]*$/,
    // regexForNatInsuranceNum : /^\s*[a-zA-Z]{2}(?:\s*\d\s*){6}[a-dA-D]{1}?\s*$/,
    regexForNatInsuranceNum : /^[0-9a-zA-Z\s-]+$/,
    regexForUKPostcodes : /^[a-z]{1,2}\d[a-z\d]?\s*\d[a-z]{2}$/,
}